export const validateRequired = (value: string | number | undefined | null): boolean => {
	if (typeof value === "number") {
		return !isNaN(value);
	}

	if (typeof value === "string") {
		return value.trim() !== "";
	}

	return value !== undefined && value !== null;
};
